/**
 * Set a local storage item
 * @param key - The key to set
 * @param value - The value to set
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function setLocalStorageItem(key: string, value: string) {
	if (typeof window === "undefined") return;
	localStorage.setItem(key, value);
}

/**
 * Get a local storage item
 * @param key - The key to get
 * @returns The value of the item
 */
export function getLocalStorageItem(key: string) {
	if (typeof window === "undefined") return "";
	return localStorage.getItem(key) || "";
}

/**
 * Delete a local storage item
 * @param key - The key to delete
 */
export function deleteLocalStorageItem(key: string) {
	if (typeof window === "undefined") return;
	localStorage.removeItem(key);
}
